import { Colors } from "@chakra-ui/react";

export const rawColors = {
  black: {
    500: "#4A4A4D",
    600: "#39393B",
    700: "#29292d",
    800: "#1A1A1E",
    900: "#010101",
  },
  blue: {
    100: "#e5faff",
    200: "#b3efff",
    300: "#95e9ff",
    400: "#95e9ff",
    500: "#66E0FF",
    600: "#60CDE9",
    700: "#00baea",
    800: "#007795",
    900: "#00556a",
  },
  gray: {
    100: "#F7F6F3",
    200: "#EDECE9",
    300: "#DCDBD9",
    400: "#C0BFBD",
    500: "#AAA9A8",
    600: "#939392",
    700: "#807F7F",
    800: "#5E5E60",
    900: "#4A4A4D",
    950: "#121212",
  },
  green: {
    300: "#A1F4A3",
    500: "#87DA89",
    600: "#72D274",
  },
  orange: {
    300: "#FFE7AA",
    500: "#FFDC85",
    600: "#F9CF64",
  },
  purple: {
    100: "#F1F4FF",
    300: "#DEE6FF",
    400: "#CCD8FF",
    500: "#B6C7FF",
    600: "#AFBFF1",
    700: "#9BABDF",
  },
  red: {
    300: "#FF7678",
    500: "#FC3D40",
    600: "#DD3033",
  },
  teal: {
    100: "#ebf5f7",
    200: "#c3e2e6",
    300: "#78b8c0",
    400: "#376F76",
    500: "#1B5B63",
    600: "#295e64",
    700: "#004750",
    800: "#19383c",
    900: "#081314",
  },
  yellow: {
    100: "#FDFEED",
    200: "#F6FCB3",
    300: "#f0f879",
    400: "#eaf543",
    500: "#EDF96F",
    600: "#D5E15C",
    700: "#b1bc0a",
    800: "#7f8607",
    900: "#4c5004",
  },
  warmgray: {
    50: "#FAF5F2",
    100: "#F0E8E4",
    200: "#E6DAD3",
    300: "#DBCDC5",
    400: "#BFB1A8",
    500: "#9C928C",
    600: "#827A75",
    700: "#615B57",
    800: "#3B3735",
    900: "#242220",
  },
  white: "#FFFFFF",
};

export const colors: Colors = rawColors;

colors.brand = colors.purple;

export const semanticColors = {
  error: {
    text: "gray.100",
    light: "red.300",
    default: "red.500",
    dark: "red.600",
  },
  success: {
    text: "black.500",
    light: "green.300",
    default: "green.500",
    dark: "green.600",
  },
  warning: {
    text: "black.500",
    light: "orange.300",
    default: "orange.500",
    dark: "orange.600",
  },
  info: {
    text: "black.500",
    light: "blue.300",
    default: "blue.800",
    dark: "blue.600",
  },
  // primary: {
  //   text: "black.500",
  //   default: "purple.500",
  //   // _dark: "purple.400",
  // },
  // secondary: {
  //   text: "gray.100",
  //   default: "teal.600",
  //   // _dark: "teal.400",
  // },
  // accent: {
  //   text: "black.500",
  //   default: "yellow.600",
  //   // _dark: "teal.400",
  // },
  text: {
    default: "black.800",
    _dark: "gray.100",
  },
  "text-muted": {
    default: "gray.700",
    _dark: "gray.400",
  },
  "chakra-body-text": {
    default: "black.800",
    _dark: "gray.100",
  },
  background: {
    base: { default: "gray.100", _dark: "gray.950" },
    subtle: { default: "gray.200", _dark: "gray.950" },
  },
};
